// Add your custom JS here.
( function( $ ) {


    // Fade in effects
    AOS.init();
    $('*[data-aos]').wrap("<div class='aos-outer'></div>");
    


    // Smooth anchor scrolling
    var scroll = new SmoothScroll('a[href*="#"]', {
        speed: 300
    });
    



    // check if page is scrolled from the top for header
    $(document).scroll(function(){
        if($(this).scrollTop() > 50)
        {   
            $('.header-menu').addClass('off-top');

        }
        if($(this).scrollTop() < 50)
        {   
            $('.header-menu').removeClass('off-top');
        }
    });



    // show header based on scroll directions
    var lastScrollTop = 0;
    $(window).scroll(function(event){
        var st = $(this).scrollTop();
        if (st > lastScrollTop){
            $('.header-menu').addClass('hide');
        } else {
            $('.header-menu').removeClass('hide');
        }
        lastScrollTop = st;
    });

    if ($(window).width() > 960) {
        // parallaxes
        var image = document.getElementsByClassName('parallaximg');
        new simpleParallax(image, {
            scale: 1.4
        });
    }


    
    // fold swiper
    var foldswiper = new Swiper(".fold-swiper", {
        slidesPerView: 1,
        center: true,
        loop: true,
        effect: "fade",
        autoplay: {
            delay: 5000,
        },
        pagination: {
            el: ".fold-swiper-pagination",
            clickable: true,
        },
    });


    // fullwidth swiper
    var fullwidthswiper = new Swiper(".fullwidth-swiper", {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 0,
        loop: true,
        autoplay: {
            delay: 5000,
        },
        effect: "creative",
        creativeEffect: {
            limitProgress: 10,
            prev: {
                // opacity: 0.45,
                scale: 0.7,
                translate: ["-25%", 0, 0],
            },
            next: {
                // opacity: 0.75,
                scale: 0.7,
                translate: ["25%", 0, 0],
            },
        },
        slideToClickedSlide: true,
        pagination: {
            el: ".fullwidth-swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: '.fullwidth-swiper-prev',
            prevEl: '.fullwidth-swiper-next',
        },
    });





    // header functions
    $(".header-toggle").on("click", function () {
        $(".header-menu").addClass('active');
    });

    $(".header-menu .close, .header-menu a").on("click", function () {
        $(".header-menu").removeClass('active');
    });




    // macro micro functions
    $(".tabs div").on("click", function () {
        var type = $(this).attr("type");

        $(this).siblings().removeClass('active');
        $(this).addClass('active');

        $('.info.macro.active, .legend.micro.active').slideUp(function(){
            $("div." + type + "").slideDown();
            $(".macro, .micro").removeClass('active');
            $("." + type + "").addClass('active');
        });
    });

    




    // plan popup functions
    $(".eye-icon").on("click", function () {
        var popupid = $(this).attr("popup");
        $("#plan-" + popupid + "").addClass('active');
    });

    $(".plan-popup .close").on("click", function () {
        $(".plan-popup").removeClass('active');
    });





    // download functions
    $(".page-template-frontpage .download-button").on("click", function (e) {
        if ($("body").hasClass("subscribed")) {
            var currentfileLink = $(this).attr("downloadlink");
            var currentfileName = $(this).attr("filename");
            $("#saentysfdbm").attr("href", currentfileLink);
            $("#saentysfdbm").attr("download", currentfileName);
            $("#saentysfdbm")[0].click();
        } else {
            var currentdownload = $(this).text();
            var currentdownloadimg = $(this).siblings('.download-image-url').text();
            $(".download-popup h3").text(currentdownload);
            $(".download-popup .gform_button").val(currentdownload);
            $(".download-popup .download-img").attr("src", currentdownloadimg);
            $(".popup-shadow").addClass("active");
            $(".download-popup").addClass("active");
            var currentfileLink = $(this).attr("downloadlink");
            var currentfileName = $(this).attr("filename");
            $("#saentysfdbm").attr("href", currentfileLink);
            $("#saentysfdbm").attr("download", currentfileName);
            $(document).on("gform_confirmation_loaded", function (e, form_id) {
                $("body").addClass("subscribed");
                $("#saentysfdbm")[0].click();
            });
        }
    });

    $(".download-popup .close, .popup-shadow").on("click", function (e) {
        $(".popup-shadow").removeClass("active");
        $(".download-popup").removeClass("active");
    });





    // navbar functions
    $("a").on("click", function () {
        $("#wrapper-navbar").removeClass("active");
    });

    $(".menu li:nth-child(1) a").addClass("projet active");
    $(".menu li:nth-child(2) a").addClass("localisation");
    $(".menu li:nth-child(3) a").addClass("offre");
    $(".menu li:nth-child(4) a").addClass("surfaces-et-disponibilites");
    $(".menu li:nth-child(5) a").addClass("contact");

    if ($("ul.menu").length) {
        $(window).on("scroll", function () {
            $(".anchor").each(function () {
                if ($(window).scrollTop() >= $(this).offset().top - 50) {
                    var currentItem = $(this).attr("id");
                    $("ul.menu a").removeClass("active");
                    $("ul.menu ." + currentItem + "").addClass("active");
                }
            });
        });
    }




    // fold animation
    gsap.registerPlugin(ScrollTrigger);

    gsap.to(".fold-swiper", {
        scrollTrigger: {
            trigger: ".section-one",
            start: "top top",
            end: '+500px', 
            scrub: true,
            pin: true,
        }
    });

    $(window).scroll(function (event) {

        if ($(window).width() < 992) {
            
            var otherscroll = $(window).scrollTop();
            var otherscroll = 160 - otherscroll;

            console.log(otherscroll);

            var scroll = $(window).scrollTop() + 300;
            var scroll = scroll/2;
            $(".fold-swiper").css("mask-size", '' + scroll + '%');

            $(".section-one").css("padding-top", 'calc(' + otherscroll + 'px)');

        }

        else {
            
            var otherscroll = $(window).scrollTop();
            var otherscroll = 160 - otherscroll;

            console.log(otherscroll);

            var scroll = $(window).scrollTop() + 400;
            var scroll = scroll/4;
            $(".fold-swiper").css("mask-size", '' + scroll + '%');

            $(".section-one").css("padding-top", 'calc(' + otherscroll + 'px)');
         }

        
    });
    

    // draw lines animation
    gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

    gsap.fromTo("#drawone", {
        drawSVG: 0
    }, {
        drawSVG: "100%",
        ease: "none",
        scrollTrigger: {
            trigger: "section.section-two",
            pin: false,
            scrub: 0.5,
            start: "top +500px",
            end: "bottom bottom"
        }
    });

    gsap.fromTo("#drawtwo", {
        drawSVG: 0
    }, {
        drawSVG: "100%",
        ease: "none",
        scrollTrigger: {
            trigger: "section.section-four",
            pin: false,
            scrub: 0.5,
            start: "top +500px",
            end: "bottom bottom"
        }
    });

    gsap.fromTo("#drawthree", {
        drawSVG: 0
    }, {
        drawSVG: "100%",
        ease: "none",
        scrollTrigger: {
            trigger: "section.section-four",
            pin: false,
            scrub: 0.5,
            start: "top +500px",
            end: "bottom bottom"
        }
    });

    gsap.fromTo("#drawfour", {
        drawSVG: 0
    }, {
        drawSVG: "100%",
        ease: "none",
        scrollTrigger: {
            trigger: "section.section-ten",
            pin: false,
            scrub: 0.5,
            start: "top +500px",
            end: "bottom bottom"
        }
    });

    gsap.fromTo("#drawfive", {
        drawSVG: 0
    }, {
        drawSVG: "100%",
        ease: "none",
        scrollTrigger: {
            trigger: "section.section-ten",
            pin: false,
            scrub: 0.5,
            start: "top +500px",
            end: "bottom bottom"
        }
    });

    gsap.to('.scaleimg', {
        scale: 1.1,
        duration: 2,
        scrollTrigger: {
          trigger: 'section.section-five',
          markers: false,
          start: 'top top',
          end: 'bottom bottom'
        }
    });


    



} )( jQuery );